import type { SetContext, GameSummary, Tournament } from "../../shared/types";

export interface SetData extends SetContext {
  id: string;
  games: string[];
  gameSummaries: GameSummary[];
  folder: string;
  /** Set when a list spans multiple tournaments (e.g. a player's cross-tournament history). */
  tournamentFolder?: string;
  tournamentSlug?: string;
}

/**
 * Flatten a tournament's sets into the shape the set list renders, optionally
 * filtered to sets featuring a player matching `playerQuery`, newest first.
 */
export function buildSetListData(tournament: Tournament, playerQuery: string): SetData[] {
  const q = playerQuery.toLowerCase();
  return tournament.sets
    .filter((s) => {
      if (!q) return true;
      return [...s.context.players.entrant1, ...s.context.players.entrant2].some((p) =>
        p.name.toLowerCase().includes(q),
      );
    })
    .map((s) => ({
      ...s.context,
      id: s.folder,
      games: s.games ?? [],
      gameSummaries: s.gameSummaries ?? [],
      folder: s.folder,
    }))
    .sort((a, b) => b.startMs - a.startMs);
}
